export default __webpack_public_path__ + "static/media/price-diagram-2.8167a27f.svg";